import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/document-redactor/")({
  beforeLoad() {
    throw redirect({
      to: "/document-redactor/options",
      mask: {
        to: "/document-redactor",
      },
    });
  },
});
